import React, { useState, useEffect } from 'react';
import emailjs from '@emailjs/browser';

const ContactForm: React.FC = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    title: 'General Inquiry',
    message: ''
  });

  // Initialize EmailJS
  useEffect(() => {
    emailjs.init('MmHPzHHwRZt5nou_c');
  }, []);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    const serviceId = 'service_u5x1t7g';
    const templateId = 'template_0jp3m0j';

    const templateParams = {
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      title: formData.title,
      message: formData.message
    };

    emailjs.send(serviceId, templateId, templateParams)
      .then((response) => {
        alert('Your message has been sent! 🎉');
        console.log('SUCCESS!', response.status, response.text);
        setFormData({ name: '', email: '', phone: '', title: 'General Inquiry', message: '' });
      })
      .catch((err) => {
        alert('Oops! Something went wrong. Please try again.');
        console.error('EmailJS error:', err);
      });
  };

  return (
    <section className="section bg-white">
      <div className="container-narrow">
        {/* Section Header */}
        <div className="text-center mb-8 sm:mb-10">
          <h2 className="section-title">Contact Us</h2>
          <p className="section-subtitle mx-auto px-4">
            Have a question or want to place a special order? We'd love to hear from you!
          </p>
        </div>

        {/* Form Card */}
        <div className="card-elevated p-6 sm:p-8 lg:p-10">
          <form onSubmit={handleSubmit} className="space-y-5">
            {/* Name & Email Row */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              <div>
                <label htmlFor="home-name" className="input-label">
                  Name
                </label>
                <input
                  type="text"
                  id="home-name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className="input"
                  placeholder="Your name"
                  required
                />
              </div>
              <div>
                <label htmlFor="home-email" className="input-label">
                  Email
                </label>
                <input
                  type="email"
                  id="home-email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="input"
                  placeholder="your@email.com"
                  required
                />
              </div>
            </div>

            {/* Phone & Reason Row */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              <div>
                <label htmlFor="home-phone" className="input-label">
                  Phone Number
                </label>
                <input
                  type="tel"
                  id="home-phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  className="input"
                  placeholder="(123) 456-7890"
                  required
                />
              </div>
              <div>
                <label htmlFor="home-title" className="input-label">
                  Reason for Contact
                </label>
                <select
                  id="home-title"
                  name="title"
                  value={formData.title}
                  onChange={handleChange}
                  className="input"
                  required
                >
                  <option value="General Inquiry">General Inquiry</option>
                  <option value="Order Request">Order Request</option>
                  <option value="Catering">Catering</option>
                  <option value="Business Partnership">Business Partnership</option>
                </select>
              </div>
            </div>

            {/* Message */}
            <div>
              <label htmlFor="home-message" className="input-label">
                Message
              </label>
              <textarea
                id="home-message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                rows={4}
                className="input resize-none"
                placeholder="How can we help you?"
                required
              />
            </div>

            {/* Submit Button */}
            <button type="submit" className="btn-primary w-full btn-lg">
              Send Message
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;
